import { removeNullCharacters } from '../../shared/utils/user_data_personaliser.js';

export function anonymize_grok_data(
    conversations,
) {
    let anonymized_user_object = {
        conversations: removeNullCharacters(conversations)
    };
    return anonymized_user_object;
}
